<div class="error-page-wrapper tui-space_vertical-4 tui-space_left-8 tui-space_right-7">
  <ng-container *ngIf="errorPageMessage$ | async as errorPageMessage">
    <ng-container *ngIf="errorPageMessage.severity === 'token'">
      <tui-notification class="notification-wrapper" [hasIcon]="false" status="info">
        <span class="ait-font-text-xl tui-space_right-2">✌️</span>
        <span class="ait-font-text-m" [innerHTML]="errorPageMessage.message"></span>
      </tui-notification>
      <button
        class="tui-space_top-2"
        (click)="loginWithFacebook(errorPageMessage?.authUrl)"
        tuiButton
        appearance="aitarget-flat"
        size="m"
        icon="https://res.cloudinary.com/aitarget/image/upload/v1616492440/platforms/facebook.svg"
      >
        {{ 'Connect Facebook' | translate }}
      </button>
    </ng-container>
  </ng-container>
</div>
